import { useNow } from "@repo/ui/timestamps/timestampContext";

/** Service access counts as ending soon within this long of its end. */
const ENDING_SOON_MS = 15 * 60 * 1000;

/**
 * The milliseconds left until `expiresAt`, as of the shared refreshing "now",
 * or null without one.
 */
export function useServiceAccessMsLeft(expiresAt: string | null) {
  const now = useNow();
  return expiresAt === null ? null : Date.parse(expiresAt) - now.toMillis();
}

/** "Expiring in 12m", rounded up to the minute so it never reads 0m. */
export function formatServiceAccessExpiringIn(msLeft: number) {
  const minutes = Math.max(1, Math.ceil(msLeft / 60_000));
  return `Expiring in ${String(minutes)}m`;
}

/** Whether service access ends within the next 15 minutes. */
export function checkIsServiceAccessEndingSoon(msLeft: number) {
  return msLeft <= ENDING_SOON_MS;
}
